// This file is auto-generated - any changes will be lost

// Page Files
import "../../src/js/pages/customers/customer-inner.js";
import "../../src/js/pages/customers/domains/domains-inner.js";
import "../../src/js/pages/customers/projects/invoice-inner.js";
import "../../src/js/pages/customers/projects/project-inner.js";
import "../../src/js/pages/customers/projects/subscription-inner.js";
import "../../src/js/pages/customers/purchase-orders/purchase-order-inner.js";
import "../../src/js/pages/login.js";